import { SEOLayout } from '@layouts';
import FAQ from './components/FAQ';
import PlanComparison from './components/PlanComparison';
import PricePlan from './components/PricePlan';
import styles from './styles.module.scss';

const Pricing = () => (
  <SEOLayout
    title="Pricing"
    description="Choose the Perfect Plan for Your Team | Invest in Your People, Invest in Your Business | Standard, Advanced, and Tailor-made Custom Options Available | Staff Onboarding, News, Quiz, Survey, Points System, Rewards, and More!"
  >
    <main className={styles.container}>
      <PricePlan />
      <PlanComparison />
      <FAQ />
    </main>
  </SEOLayout>
);

export default Pricing;
